import { useTranslation } from 'react-i18next';

import RealitiqLogo from '@/assets/realitiq-logo.png';
import { env } from '@/constants/env';
import type { Estate } from '@/features/estates-property/api/estate';
import { cn } from '@/lib/utils';

interface PrintContainerProps extends React.PropsWithChildren {
  hasFooter?: boolean;
  header?: string;
  hide?: boolean;
  isLastPage?: boolean;
  estate: Estate;
}

export const PrintContainer: React.FC<PrintContainerProps> = ({
  estate,
  header,
  children,
  hide = false,
  hasFooter = true,
  isLastPage = false,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={cn('print-container bg-background-lighter print:bg-white', hide && 'print-hidden')}
    >
      <div className="print-content">
        <h2 className="print-only text-[26px] font-bold leading-tight text-primary-light">
          {header}
        </h2>
        {children}
      </div>
      {hasFooter ? (
        <div className="print-only px-7 py-1">
          <div className="h-px w-full bg-black" />
          <div className="flex items-center justify-between">
            <div>
              <img
                src={`${env.API_URL}/images/${estate.tenant?.logoId}`}
                alt="Tenant Logo"
                className="h-10"
              />
            </div>
            <div className="text-[8px] leading-tight">
              <div className="flex items-center gap-0.5">
                <p>{t('poweredBy')}</p>
                <img src={RealitiqLogo} alt="Realitiq Logo" className="h-6 w-6" />
              </div>
              <p className="mb-0.5">www.realitiq.com</p>
              <p>www.pricehubble.com</p>
            </div>
          </div>
        </div>
      ) : null}
      {isLastPage ? null : <div className="break-before-page" />}
    </div>
  );
};
